export default __webpack_public_path__ + "static/media/Aaron-Zhang.0b51cc62.png";